import ajaxOpenButton from 'utils/_ajax-open-button.js'
import adminUserEdit from '3-section/section-admin-user-edit/_index.js'
import {deleteBtnHandler, deleteAction} from 'utils/_delete-user.js'
import updateListCommon from 'utils/_update-list-common.js'

export default (data) => {

  updateListCommon(data)

  document.querySelectorAll('.user-list__edit').forEach((e) => {ajaxOpenButton(
    e,
    '.user-list__body-item',
    '/{!_locale}/admin/users/{!id}/edit',
    adminUserEdit
  )})


  document.querySelectorAll('.user-list__delete').forEach((element) => {
    element.addEventListener('click', deleteBtnHandler)
  })

}

